import SecurityIcon from "@mui/icons-material/Security";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import image5 from '../assets/img/image-5.png';

const FeaturesSection = () => {
  // Data for feature cards
  const features = [
    {
      title: "Secure Uploads",
      description:
        "Enjoy the peace of mind that comes with our reliable and secure file upload process, designed to protect your valuable data",
      icon: <SecurityIcon sx={{ fontSize: 80, color: "#FFD700" }} />,
    },
    {
      title: "Seamless Integration",
      description:
        "Integrate our platform effortlessly with your existing systems for a seamless data migration experience",
      icon: <SyncIcon sx={{ fontSize: 80, color: "#FFD700" }} />,
    },
  ];

  return (
    <Box
      sx={{ width: "100%", bgcolor: "#080808", py: 15, position: "relative" }}
    >
      <Grid container spacing={4} sx={{ mx: "auto", display: "flex", flexDirection: {xs: "column", sm: "row"} }}>
        {/* Left side - Image */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1
          }}
        >
          <Box
            component="img"
            src={image5}
            alt="Data migration illustration"
            sx={{ maxWidth: "100%", height: "auto" }}
          />
        </Grid>

        {/* Right side - Content */}
        <Grid item xs={12} md={7} sx={{flex: 1}}>
          <Stack spacing={3}>
            {/* Heading and description */}
            <Typography
              variant="h4"
              sx={{
                color: "#fefdfd",
                fontFamily: "'Spline Sans Mono', monospace",
                fontWeight: 600,
                fontStyle: "italic",
                fontSize: "26px",
                lineHeight: "31.2px",
                p: 2
              }}
            >
              Unlock the Power of Data Migration
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#7a7976",
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "15px",
                lineHeight: "29.1px",
                maxWidth: "533px",
                p: 2
              }}
            >
              Discover the ultimate solution for seamless file transfers. Our
              platform combines top-tier security, flexible accessibility, and
              24/7 support, empowering you to migrate your digital assets with
              confidence
            </Typography>

            {/* Feature cards */}
            <Grid container spacing={4} sx={{ mt: 4, justifyContent: "center"}}>
              {features.map((feature, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Stack alignItems="center" spacing={2}>
                    <Box
                      sx={{ height: 80, display: "flex", alignItems: "center" }}
                    >
                      {feature.icon}
                    </Box>
                    <Typography
                      variant="h6"
                      align="center"
                      sx={{
                        color: "#e4e2e2",
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "18px", md: "21px" },
                        lineHeight: "25.2px",
                        width: "100%",
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      align="center"
                      sx={{
                        color: "#71706b",
                        fontFamily: "'Space Grotesk', sans-serif",
                        fontSize: "14px",
                        lineHeight: "29px",
                        maxWidth: "244px",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FeaturesSection;